import ApiConfig from './../../../components/common/apiConfig';

export function workwithus_v1_insert(data) {

  let config = {
    url: "insert_request"
  };

  let _data = {
    table: "workwithus",
    method_type: "insert",
    ...data
  };

  return ApiConfig(config, _data);
};
